import styled from 'styled-components'

import { IconProps } from '.'
import BaseSvg from './BaseSvg'

const StyledIcon = styled(BaseSvg)`
  width: 22px;
  height: 29px;
  color: ${({ color }: any) => color || '#094994'};
`

const TestBot = ({ color, title = 'Code Tag', ...rest }: IconProps & { color?: string }) => (
  // @ts-expect-error
  <StyledIcon viewBox="0 0 22 29" color={color} title={title} {...rest}>
    <path
      d="M3.64 27.7h14.58a2.391 2.391 0 001.92-3.84L13.3 14.5V4.9h3V1.3H5.5v3.6h3v9.6l-6.84 9.36a2.429 2.429 0 001.98 3.84z"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </StyledIcon>
)

TestBot.needsWork = true
export default TestBot
